export const getSettings = state => state.settings;


// WEBPACK FOOTER //
// ./src/selectors/settings.js